import React from 'react';
import {observer, inject} from 'mobx-react';
import m from 'moment';
import classnames from 'classnames';
import styles from './EventView.css';

import Event from '../Event';
import EditEventView from './EditEventView';

function EventView({event, store, view}) {
  const classNames = classnames({
    [styles.wrapper]: true,
    [styles.in]: event.event === 'in',
    [styles.out]: event.event === 'out'
  });

  const handleEditEvent = () => {
    if (!view.userHasGroup(store.routeInfo.edit)) return console.log('user not allowed to edit');
    store.setEditableEvent({
      id: event.id,
      personId: event.personId,
      event: event.event,
      time: event.time
    });
    store.toggleEditing();
  };

  return (
    <div
      className={classNames}
      onClick={handleEditEvent}
    >
      {event.time ? m(event.time).format('HH:mm:ss') : ''}
    </div>
  );
}

export default inject('view')(observer(EventView));


// WEBPACK FOOTER //
// ./src/views/Beeper/Components/EventView.js